<div class="head">
  <h1 class="page-title">Savings</h1>
</div>

<p class="loading" *ngIf="loading">Loading…</p>
<p class="error" *ngIf="error">{{ error }}</p>

<ng-container *ngIf="!loading && !error">
  <div class="lbl">Goals · {{ goals.length }}</div>

  <p class="empty" *ngIf="!goals.length">
    No goals yet. Add one below to see how long it takes at a given monthly rate.
  </p>

  <div class="row" *ngFor="let g of goals; trackBy: trackGoal">
    <ng-container *ngIf="editingId !== g.id">
      <span class="name">{{ g.name }}</span>
      <span class="amt">{{ fmt(g.targetCents) }}</span>
      <span class="rate">{{ fmt(g.monthlyCents) }}/mo</span>
      <span class="months" *ngIf="monthsFor(g) !== null">
        {{ monthsFor(g) }} month{{ monthsFor(g) === 1 ? '' : 's' }} · {{ dateFor(g) + 'T00:00:00' | date:'MMM y' }}
      </span>
      <span class="months none" *ngIf="monthsFor(g) === null">
        {{ noDateReason(g) }}
      </span>
      <button class="link-btn" (click)="startEdit(g)">edit</button>
      <button class="link-btn" (click)="removeGoal(g)">remove</button>
    </ng-container>
    <ng-container *ngIf="editingId === g.id">
      <input class="f-name" [(ngModel)]="editDraft.name">
      <input class="f-num" [(ngModel)]="editDraft.target" inputmode="decimal">
      <input class="f-num" [(ngModel)]="editDraft.monthly" inputmode="decimal">
      <button class="btn" (click)="saveEdit()" [disabled]="!canSaveEdit">Save</button>
      <button class="link-btn" (click)="cancelEdit()">cancel</button>
    </ng-container>
  </div>

  <div class="add">
    <input class="f-name" [(ngModel)]="draft.name" placeholder="Goal name">
    <input class="f-num" [(ngModel)]="draft.target" inputmode="decimal" placeholder="Target $">
    <input class="f-num" [(ngModel)]="draft.monthly" inputmode="decimal" placeholder="Monthly $">
    <button class="btn" (click)="addGoal()" [disabled]="!canAdd">Add goal</button>
  </div>

  <div class="chips" *ngIf="chips.length">
    <span class="chips-lbl">Your monthly net:</span>
    <button class="chip" *ngFor="let c of chips" (click)="useChip(c)">
      {{ c.label }} {{ fmt(c.monthlyCents) }}
    </button>
  </div>
  <p class="hint" *ngIf="chips.length">
    These differ because your monthly net does. Tap one to fill the field, then edit freely.
  </p>
  <p class="hint" *ngIf="!chips.length">
    Not enough history yet to suggest a monthly figure.
  </p>

  <div class="lbl second">Growth projection</div>

  <div class="proj-inputs">
    <label>Starting capital
      <input class="f-num" [(ngModel)]="projDraft.start" inputmode="decimal"
             (input)="previewProjection()" (change)="commitProjection()"></label>
    <label>Monthly investment
      <input class="f-num" [(ngModel)]="projDraft.monthly" inputmode="decimal"
             (input)="previewProjection()" (change)="commitProjection()"></label>
    <label>Years
      <input class="f-num" type="number" [min]="yearsMin" [max]="yearsMax"
             [(ngModel)]="projection.years" (change)="commitProjection()"></label>
  </div>

  <div class="rate-row">
    <label for="rate">Annual return</label>
    <input id="rate" type="range"
           [min]="rateMin" [max]="rateMax" [step]="rateStep"
           [(ngModel)]="projection.rateBasisPoints" (change)="commitProjection()">
    <span class="rate-val num">{{ ratePercent }}</span>
  </div>

  <div class="proj-result">
    <span class="proj-total num">{{ fmt(endingBalanceCents) }}</span>
    <span class="proj-cap">after {{ boundedYears }} years at {{ ratePercent }}</span>
  </div>

  <mm-line [points]="projectionPoints"
           [displayValues]="projectionDisplay"
           [ariaLabel]="'Projected balance over ' + boundedYears + ' years'"></mm-line>

  <table class="milestones" *ngIf="milestones.length">
    <tbody>
      <tr *ngFor="let m of milestones">
        <th scope="row">{{ m.years }} years</th>
        <td class="num">{{ fmt(m.cents) }}</td>
      </tr>
    </tbody>
  </table>

  <p class="hint">
    Arithmetic only — no tax, fees, or inflation, and the rate is whatever the
    slider says rather than a prediction.
  </p>
</ng-container>
